// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

import CustomEntryValuesUpload from "entity/CustomEntryValuesUpload";
import Paging from "./Paging";
import SocialEntryConfiguration from "entity/SocialEntryConfiguration";

import { QueryParams, RestController, RestRequest } from "./RestController";

export default class RulesController extends RestController {

    apiKeyGetEntryConfiguration(socialRoomSetId: string, configurationId: string): Promise<SocialEntryConfiguration> {
        let request = new RestRequest("/api/v1/rules/api/key/entry/config", "GET", null, { socialRoomSetId: socialRoomSetId, configurationId: configurationId });
        return this.request(request, null) as Promise<SocialEntryConfiguration>;
    }

    apiKeyUCreateEntryConfiguration(socialRoomSetId: string, config: SocialEntryConfiguration): Promise<void> {
        let request = new RestRequest("/api/v1/rules/api/key/entry/config", "POST", config, { socialRoomSetId: socialRoomSetId });
        return this.requestVoid(request);
    }

    apiKeyUpdateEntryConfiguration(socialRoomSetId: string, config: SocialEntryConfiguration): Promise<void> {
        let request = new RestRequest("/api/v1/rules/api/key/entry/config", "PUT", config, { socialRoomSetId: socialRoomSetId });
        return this.requestVoid(request);
    }

    apiKeyUploadCustomValues(socialRoomSetId: string, valuesCSV: string, removeOld?: boolean): Promise<CustomEntryValuesUpload> {
        const queryParams: QueryParams = { socialRoomSetId: socialRoomSetId };
        if (removeOld !== undefined) {
          queryParams.removeOld = removeOld;
        }
        let request = new RestRequest("/api/v1/rules/api/key/upload/value", "POST", valuesCSV, queryParams);
        return this.request(request, null) as Promise<CustomEntryValuesUpload>;
    }

    createEntryConfiguration(socialRoomSetId: string, config: SocialEntryConfiguration): Promise<void> {
        let request = new RestRequest("/api/v1/rules/entry/config", "POST", config, { socialRoomSetId: socialRoomSetId });
        return this.requestVoid(request);
    }

    getEntryConfiguration(socialRoomSetId: string, configurationId: string): Promise<SocialEntryConfiguration> {
        let request = new RestRequest("/api/v1/rules/entry/config/details", "GET", null, { socialRoomSetId: socialRoomSetId, configurationId: configurationId });
        return this.request(request, null) as Promise<SocialEntryConfiguration>;
    }

    getEntryConfigurations(socialRoomSetId: string, page?: Paging): Promise<SocialEntryConfiguration[]> {
        let request = new RestRequest("/api/v1/rules/entry/config", "GET", null, { socialRoomSetId: socialRoomSetId });
        if (page) request.addPaging("", page);

        return this.request(request, null) as Promise<SocialEntryConfiguration[]>;
    }

    removeEntryConfiguration(socialRoomSetId: string, configurationId: string): Promise<void> {
        let request = new RestRequest("/api/v1/rules/entry/config/saved", "DELETE", null, { socialRoomSetId: socialRoomSetId, configurationId: configurationId });
        return this.requestVoid(request);
    }

    updateEntryConfiguration(socialRoomSetId: string, config: SocialEntryConfiguration): Promise<void> {
        let request = new RestRequest("/api/v1/rules/entry/config", "PUT", config, { socialRoomSetId: socialRoomSetId });
        return this.requestVoid(request);
    }

    uploadCustomValues(socialRoomSetId: string, valuesCSV: string, removeOld?: boolean): Promise<CustomEntryValuesUpload> {
        const queryParams: QueryParams = { socialRoomSetId: socialRoomSetId };
        if (removeOld !== undefined) {
          queryParams.removeOld = removeOld;
        }
        let request = new RestRequest("/api/v1/rules/upload/value", "POST", valuesCSV, queryParams);
        return this.request(request, null) as Promise<CustomEntryValuesUpload>;
    }

}
